import { api } from '../lib/api';

export interface Comment {
  id: string;
  content: string;
  postId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  user: {
    id: string;
    name: string;
    profileImageUrl: string | null;
  };
  _count?: {
    likes: number;
  };
  likes?: Array<{ user: { id: string; name: string } }>;
}

export interface CreateCommentInput {
  content: string;
}

/**
 * Get comments for a post
 */
export const getComments = async (postId: string): Promise<Comment[]> => {
  const response = await api.get<Comment[]>(`/posts/${postId}/comments`);
  return response.data;
};

/**
 * Create a comment on a post
 */
export const createComment = async (
  postId: string,
  input: CreateCommentInput
): Promise<Comment> => {
  const response = await api.post<Comment>(
    `/posts/${postId}/comments`,
    input
  );
  return response.data;
};

/**
 * Delete a comment
 */
export const deleteComment = async (commentId: string): Promise<void> => {
  await api.delete(`/posts/comments/${commentId}`);
};

/**
 * Admin: notify all users about a post
 */
export const notifyAllAboutPost = async (postId: string): Promise<{ notifiedCount: number }> => {
  const response = await api.post<{ notifiedCount: number }>(`/posts/${postId}/notify-all`);
  return response.data;
};
export const toggleCommentLike = async (commentId: string): Promise<{ liked: boolean; message: string }> => {
  const response = await api.post<{ liked: boolean; message: string }>(`/comments/${commentId}/likes`);
  return response.data;
};

/**
 * Check if user has liked a comment
 */
export const hasUserLikedComment = async (commentId: string): Promise<boolean> => {
  const response = await api.get<{ hasLiked: boolean }>(`/comments/${commentId}/likes/me`);
  return response.data.hasLiked;
};
